// extracted by mini-css-extract-plugin
export default {"root":"FileDetails_root__AKhB1"};